import $ from 'jquery';
import plugin from '../../lib/plugin';

export const ELEMENT_SELECTOR = '[data-search-dropdown]';
export const PLUGIN_NAME = 'searchDropdown';

export function exec () {

    $(document).ready(() => {
        const $elements = $(ELEMENT_SELECTOR);

        if ($elements && $elements.length) {

            const {SearchDropdown} = require('./plugin');
            plugin(PLUGIN_NAME, SearchDropdown);

            $elements.each(function () {
                $(this)[PLUGIN_NAME]();
            });

        }

    });

}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/search-dropdown/index.js